import React from "react";
import { Link } from "react-router-dom";
import "../styles/Impressum.css";

const Impressum = () => (
  <div className="impressum-page">
    <h1>Impressum</h1>

    <section className="impressum-section">
      <h2>Angaben gemäß § 5 TMG</h2>
      <p>
        Tennisgemeinschaft Thedinghausen e. V.<br />
        Am Burgplatz 7<br />
        27321 Thedinghausen
      </p>
    </section>

    <section className="impressum-section">
      <h2>Kontakt</h2>
      <p>
        E-Mail: <a href="mailto:tgt@tennis-thedinghausen.de">tgt@tennis-thedinghausen.de</a><br />
        Tel: 01514 6154348
      </p>
    </section>

    <section className="impressum-section">
      <h2>Vereinsregister</h2>
      <p>Eingetragen beim Amtsgericht Walsrode</p>
    </section>

    <section className="impressum-section">
      <h2>Vorstand</h2>
      <div className="impressum-vorstand">
        <div>
          <strong>1. Vorsitzender</strong><br />
          Michael Thesen<br />
          Müggenort 40, 27321 Thedinghausen<br />
          Tel.: 01514 / 6154348
        </div>
        <div>
          <strong>2. Vorsitzender</strong><br />
          Lars Repenning<br />
          Auf der Bünte 11, 27321 Thedinghausen<br />
          Tel.: 0172 / 4163541
        </div>
      </div>
    </section>

    <section className="impressum-section">
      <h2>Datenschutz</h2>
      <p>
        Informationen zur Verarbeitung personenbezogener Daten finden Sie in unserer{" "}
        <Link to="/datenschutz">Datenschutzerklärung</Link>.
      </p>
    </section>
  </div>
);

export default Impressum;
